// extracted by mini-css-extract-plugin
export default {"root":"root--kFDgY","image":"image--vQJ_9","text":"text--bzkva","close":"close--e9Ww5"};